<div *ngIf="loading$|async">  
  t
  load-indicator works!
</div>
